/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useRef } from 'react'
import { useState , useEffect} from 'react'
import { fetchTaskList, totalTaskCount } from '../../Components/action/common'
import CompletedAndTrashList from './CompletedAndTrashList'
import { useDispatch , useSelector } from 'react-redux'
import { setCompletedTaskList, setTotalCount } from '../../redux/slices/TaskSlice'
import AllLoader from '../../Components/SkeletonLoading/AllLoader'
import moment from 'moment'
import AddTaskStatic from '../AddTasks/AddTaskStatic'

function Completed() {
  // dispatch
  const dispatch=useDispatch()
  const [isLoader,setIsLoader]=useState(false)
  const currentTimes = moment().startOf('date')
  const [currentTime, setCurrentTime] = useState(new Date(currentTimes));
  const wrapperRef = useRef(null)

  // global state
  const { completedTaskList  } =useSelector(state=>state.task)
  const { theme } =useSelector(state=>state.theme)

  // action
  const fetchAddTaskData = async (type) => {
    if(type == undefined){
      setIsLoader(true)
    }
    
    try {
      let response = await fetchTaskList({"status":1})
      setIsLoader(false)
      dispatch(setCompletedTaskList(response?.data?.responseData.filter(item => item.status == 1)))
    } catch ({ response }) {
      setIsLoader(false)
    }
  }

  const fetchTotalCount=async()=>{
    try {
      let response=await totalTaskCount({"date":currentTime.toISOString()})
      dispatch(setTotalCount(response?.data?.responseData))
    } catch ({response}) {
      
    }
  }

  useEffect(()=>{
    fetchAddTaskData()
    fetchTotalCount()
  },[])

  // useEffect(() => {
  //   if(isLoader) return;

  //   const bound = wrapperRef.current.getBoundingClientRect()
  //   wrapperRef.current.style.height = window.innerHeight - bound.top + 'px'
  // }, [isLoader])

  return (
    <div css={{
      '#tasks-list-wrapper':{
        '.task-list-completed':{
          overflowY: 'auto !important',
          overflowX: 'hidden !important'
        }
      }
    }}>
    {
      isLoader ? <AllLoader/> :  <>
      <div id="tasks-list-wrapper" ref={wrapperRef} className="overdue-form task-list-page rounded-t-[25px] bg-white dark:relative dark:darkmode-background dark:darkmode-blur-before !h-[100vh]">
        <div className="task-list !pb-[1.25rem]"> 
          <div className="task-list-data h-full">
            <div className="ul-task-list h-full">
              <div className="task-list task-list-completed  !pb-[1.25rem]">
                <div className="task-list-data">
                <AddTaskStatic currentPage="completedList" classNames="pt-5 bg-none" className="bg-none"/>
                  <ul className="">
                    <CompletedAndTrashList 
                    // completedList={true}
                    list={completedTaskList}
                    currentPage="completedList"
                    fetchAddTaskData={fetchAddTaskData}
                    />
                  </ul>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>  
    }
    </div>
  )
}

export default Completed